<a class="skip-link" href="#conteudo-principal"> Pular para o conteúdo principal </a>
<app-header />
<app-toaster />
<app-modal />
<app-boleto-modal />
<app-pix-modal />
<app-loader />
<main id="conteudo-principal" tabindex="-1" [attr.inert]="loaderService.isLoading() || null" style="outline: none; min-height: calc(100vh - 58px); padding-top: 1rem">
  <router-outlet />
</main>
<app-footer />
@if (showToTop()) {
  <button
    id="toTop"
    class="no-print no-mobile"
    type="button"
    aria-label="Voltar ao topo da página"
    (click)="scrollToTop()"></button>
}
